/**
 * Material UI color palette
 */

const palette = {
  primary: {
    main: '#D80102',
    clicked: '#C81D1D',
    disabled: '#E07C7C',
  },
  toast: {
    error: '#FF5A5F',
  },
  secondary: {
    main: '#F5E5D5',
    clicked: '#D9BFA0',
  },
  tertiary: {
    main: '#8B3616',
    dark: '#3F1203',
  },
  background: {
    default: '#fff',
    secondary: '#F5E5D5',
  },
  text: {
    primary: '#161718',
    secondary: '#757575',
    tertiary: '#B3B3B3',
    contrast: '#FFF',
    info: '#757575',
    green: '#28A745',
    primaryColor: '#D80102',
    primaryColorDisabled: '#E07C7C',
    onSurface: '#F5E5D5',
  },
  border: {
    default: '#E5E1DF',
    hover: '#161718',
    focus: '#D80102',
    pink: '#D801021A',
  },
  surface: {
    lightest: '#FAF8F6',
    lighter: '#F1EFED',
    light: '#E5E1DF',
    darkest: '#343332',
    white: '#fff',
    warm: '#FCFAF8',
  },
  arrow: {
    active: '#D80102',
    disabled: '#757575',
    default: '#99B2C6',
  },
  status: {
    new: {
      main: '#11457E',
      background: 'rgba(17, 69, 126, 0.05)',
    },
    in_progress: {
      main: '#F49404',
      background: 'rgba(244, 148, 4, 0.05)',
    },
    completed_ready: {
      main: '#28A745',
      background: '#28A7450D',
    },
    done: {
      main: '#757575',
      background: 'rgba(0, 0, 0, 0.14)',
    },
    active: {
      main: 'rgba(40, 167, 69, 0.87)',
      background: 'rgba(40, 167, 69, 0.05)',
    },
    inactive: {
      main: 'rgba(108, 117, 125, 0.87)',
      background: 'rgba(110, 119, 127, 0.05)',
    },
    cancelled: {
      main: '#D80102',
      background: 'rgba(216, 1, 2, 0.05)',
    },
  },
  icon: {
    default: '#7D7D7D',
    checked: '#D80102',
  },
};

export default palette;
